import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const SPLITS_CREATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/splits/create`;

export const SPLITS_UPDATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/splits/update`;
